import { useTranslation } from '../../i18n/useTranslation';
import styles from './fixcenter-career-job-offers.module.scss';
import { useEffect, useState } from 'react';
import { JobOfffer } from './fixcenter-career-job-offer.model';
import { getJoboffers } from './fixcenter-career.service';
import { Link } from 'react-router-dom';

const CareerJobOffers: React.FC = () => {
    const { t } = useTranslation('translation');
    const [data, setData] = useState<JobOfffer[]>([]);
    const [selectedItem, setSelectedItem] = useState(-1);

    useEffect(() => {
        setData(getJoboffers());
    }, []);

    return (
        <>
            <div className={styles.container}>
                <ul>
                    {data.map((item, index) => (
                        <li>
                            <Link
                                className={styles.link}
                                target={'_blank'}
                                style={{ textDecoration: 'none' }}
                                to={item.linkTo}
                                onClick={() => setSelectedItem(index)}
                            >
                                <span className={`${selectedItem === index ? styles.active : ''}`}>{t(item.name)}</span>
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
};

export default CareerJobOffers;
